import { render } from "./AttendanceTag.vue?vue&type=template&id=202030cc&scoped=true"
import script from "./AttendanceTag.vue?vue&type=script&lang=js"
export * from "./AttendanceTag.vue?vue&type=script&lang=js"

import "./AttendanceTag.vue?vue&type=style&index=0&id=202030cc&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-202030cc"]])

export default __exports__